// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// The controller name of the permission.
// Example: "Admin"

export const permissionControllerNameMinLength = 1;
export const permissionControllerNameMaxLength = 128;

export const PermissionControllerNameSchema = t.refinement(t.string, n => n.length >= permissionControllerNameMinLength && n.length <= permissionControllerNameMaxLength, 'PermissionControllerName');

export type PermissionControllerName = string;
